import { triggerState, handleChange } from '../config'

const states = {
  o_rootData: {},//地图所有数据
  n_areaIndex: 0,//区域索引
  n_deviceIndex: 0//设备索引
};
export default {
  namespaced: true,
  state: handleChange({ states, namespace: 'home' }),
  mutations: {
    changeRootData(state, payload) {
      triggerState({ state, property: "o_rootData", payload, namespace: "home" });
    },
    changeAreaIndex(state, payload) {
      triggerState({ state, property: "n_areaIndex", payload, namespace: "home" });
    },
    changeDeviceIndex(state, payload) {
      triggerState({ state, property: "n_deviceIndex", payload, namespace: "home" });
    }
  },
  actions: {

  },
  getters: {
    o_curArea(state, getters) {
      return state.o_rootData.areas[state.n_areaIndex];
    },
    n_areaId(state, getters) {
      return getters.o_curArea.id;
    },
    s_appId(state, getters) {
      return getters.o_curArea.systemFlag;
    },
    n_deviceId(state, getters) {
      return getters.o_curArea.itemId;
    },
    s_areaName(state, getters) {
      return getters.o_curArea.name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js